import kitchenInstance from '../instance'

const getKitchenConfigs = () => {
	return kitchenInstance.get('/kitchenConfigs')
}

export default getKitchenConfigs
